module.exports = __webpack_public_path__ + "img/chat_bot.c582bc0.png";